import { RolesScreen } from '../features/roles/RolesScreen'

export function RolesPage() {
  return <RolesScreen />
}
